<template>
  <CCard>
    <CCardHeader>
      <strong>
        {{$t('reservations_calendar')}}
      </strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol col="12" md="6" class="calendar-column">
          <div class="reservation-calendar">
            <div class="calendar-header mb-3">
              <CButtonGroup>
                <CButton color="outline-secondary" @click="previousMonth">
                  {{$t('last_month')}}
                </CButton>
                <CButton color="outline-secondary" style="font-size: 16px;font-weight: bold;padding: 6px 30px;" disabled>
                  {{ currentMonthName }} {{ currentYear }}
                </CButton>
                <CButton color="outline-secondary" @click="nextMonth">
                  {{$t('next_month')}}
                </CButton>
              </CButtonGroup>
            </div>
            
            <div class="calendar-grid">
              <div class="calendar-weekdays">
                <div class="calendar-day-header" v-for="day in weekDays" :key="day">{{ day }}</div>
              </div>
              <div class="calendar-days">
                <div 
                  v-for="(day, index) in calendarDays" 
                  :key="index"
                  :class="['calendar-day', { 'other-month': !day.isCurrentMonth, 'today': day.isToday, 'selected': day.date === selectedDate }]"
                  @click="selectDay(day.date)"
                >
                  <div class="day-number">{{ day.day }}</div>
                  <div v-if="day.reservationCount > 0" class="reservation-badge">
                    {{ day.reservationCount }} 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CCol>
        <CCol>
          <BookingCalendar :reservations="sortedReservations"/>

        </CCol>
        <CCol col="12" md="4" class="reservations-column">
          <div class="reservations-list">
        <CCard>
          <CCardHeader>
            <strong>
              {{$t('free_hours')}}
              {{get_user_name()}}
              {{$t('in')}}
              {{ selectedDateFormatted }}</strong>
          </CCardHeader>
          <CCardBody>
            <div class="free-times-container">
              <div v-for="(time,index) in free_times" :key="'free'+index" class="free-time-item">
                {{time}}
              </div>
            </div>
          </CCardBody>
        </CCard>
        <CCard>
          <CCardHeader>
            <strong>{{ $t('reservations_in') }} {{ selectedDateFormatted }}</strong>
          </CCardHeader>
          <CCardBody>
            <div v-if="sortedReservations.length === 0" class="text-center text-muted py-4">{{ $t('no_reservation_in_this_day') }}</div>
            <table v-else class="table table-hover table-striped reservations-table" style="width: 100%;">
              <thead>
                <tr>
                  <th>{{ $t('customer') }}</th>
                  <th>{{ $t('line') }}</th>
                  <th>{{ $t('person') }}</th>
                  <th>{{ $t('hour') }}</th>
                  <th>{{ $t('operation') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(reservation, index) in sortedReservations" :key="index" :class="`reservation-row ${reservation.status==0?'reservation-cancel':''}`">
                  <td style="font-size: 13px;">{{ reservation.user ? reservation.user.name : '-' }}</td>
                  <td style="font-size: 13px;">{{ reservation.line ? reservation.line.title : '-' }}</td>
                  <td style="font-size: 13px;">{{ reservation.admin ? reservation.admin.name : '-' }}</td>
                  <td style="font-size: 13px;">{{ getReservationTime(reservation) }}</td>
                  <td class="text-end ">
                    <div class="button-group">
                      <CButton
                        v-if="$i18n.locale=='fa' && reservation.user && reservation.user.phone"
                        color="success"
                        size="sm"
                        :href="'tel:' + reservation.user.phone"
                        class="call-button"
                      >
                        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16.5562 12.9062L16.1007 13.359C16.1007 13.359 15.0181 14.4355 12.0631 11.4972C9.10812 8.55901 10.1907 7.48257 10.1907 7.48257L10.4775 7.19738C11.1841 6.49484 11.2507 5.36691 10.6342 4.54348L9.37326 2.85908C8.61028 1.83992 7.13596 1.70529 6.26145 2.57483L4.69185 4.13552C4.25823 4.56668 3.96765 5.12559 4.00289 5.74561C4.09304 7.33182 4.81071 10.7447 8.81536 14.7266C13.0621 18.9492 17.0468 19.117 18.6763 18.9651C19.1917 18.9171 19.6399 18.6546 20.0011 18.2954L21.4217 16.883C22.3806 15.9295 22.1102 14.2949 20.8833 13.628L18.9728 12.5894C18.1672 12.1515 17.1858 12.2801 16.5562 12.9062Z" fill="white"/>
                        </svg>{{ $t('call') }}</CButton>
                      <CButton
                        v-if="reservation.status==1"
                        color="danger"
                        size="sm"
                        @click="delete_item_dialog(reservation)"
                        class="call-button"
                      >
                        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 6L6 18M6 6L18 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>{{ $t('cancel_reservation') }}</CButton>
                      <span v-if="(!reservation.user || !reservation.user.phone) && reservation.status!=1" class="text-muted">-</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </CCardBody>
        </CCard>
          </div>
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import moment from 'moment-jalaali';
import {bus} from "../../main";
import axios from 'axios'
import BookingCalendar from "../../containers/BookingCalendar.vue";
export default {
  name: 'ReservationCalendar',
  components: {BookingCalendar},
  props: {
    reservations: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      confirm_delete_name:'delete_rezervation_'+new Date().getTime()+"_"+this.$vnode.tag,
      free_times:[],
      selected_delete: {},
      currentDate: moment(),
      selectedDate: moment().format('YYYY-MM-DD'),
      weekDays:[],
    }
  },
  mounted() {
    if(this.$i18n.locale=='fa'){
      this.weekDays= [this.$t('saturday'), this.$t('sunday'), this.$t('monday'), this.$t('tuesday'),
        this.$t('wednesday'), this.$t('thursday'), this.$t('friday')]
    }else{
      this.weekDays= [this.$t('sunday'), this.$t('monday'), this.$t('tuesday'),
        this.$t('wednesday'), this.$t('thursday'), this.$t('friday'),this.$t('saturday')]
    }
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data=='true'){
        this.delete_reservation();

      }else{
        this.selected_delete = {};
      }
    });
    this.get_times_for_reserve();

    },
  computed: {
    currentYear() {
      if(this.$i18n.locale=='fa'){
        return this.currentDate.format('jYYYY');

      }else{
        return this.currentDate.format('YYYY');
      }
    },
    currentMonthName() {
      if(this.$i18n.locale=='fa'){
        return this.currentDate.format('jMMMM');

      }else{
        return this.currentDate.locale('en').format('MMMM');
      }
    },
    calendarDays() {
      const days = [];
      let startOfMonth=null
      let endOfMonth=null
      if(this.$i18n.locale=='fa'){
         startOfMonth = this.currentDate.clone().startOf('jMonth');
         endOfMonth = this.currentDate.clone().endOf('jMonth');
      }else{
         startOfMonth = this.currentDate.clone().startOf('Month');
         endOfMonth = this.currentDate.clone().endOf('Month');
      }

      const startDate = startOfMonth.clone().startOf('week');
      const endDate = endOfMonth.clone().endOf('week');
      
      const today = moment();
      
      let currentDate = startDate.clone();

      while (currentDate.isSameOrBefore(endDate, 'day')) {
        const dateStr = currentDate.format('YYYY-MM-DD');
        const reservationCount = this.getReservationCount(dateStr);
        const isCurrentMonth = currentDate.isSame(this.currentDate, 'month');
        const isToday = currentDate.isSame(today, 'day');
        if(this.$i18n.locale=='fa'){
          days.push({
            day: currentDate.format('jDD'),
            date: dateStr,
            isCurrentMonth,
            isToday,
            reservationCount
          });
        }else{
          days.push({
            day: currentDate.format('DD'),
            date: dateStr,
            isCurrentMonth,
            isToday,
            reservationCount
          });
        }


        
        currentDate.add(1, 'day');
      }
      
      return days;
    },
    selectedDateFormatted() {
      if(this.$i18n.locale=='fa') {
        return moment(this.selectedDate).locale('fa').format('jYYYY/jMM/jDD');

      }else{
        return moment(this.selectedDate).locale('en').format('YYYY/MM/DD');

      }
    },
    selectedDayReservations() {
      if (!this.reservations || this.reservations.length === 0) {
        return [];
      }
      
      return this.reservations.filter(reservation => {
        if (!reservation.reserve_time || !reservation.reserve_time.date) {
          return false;
        }
        const reserveDate = moment(reservation.reserve_time.date).format('YYYY-MM-DD');
        return reserveDate === this.selectedDate;
      });
    },
    sortedReservations() {
      const reservations = this.selectedDayReservations;
      return reservations.sort((a, b) => {
        const timeA = this.getReservationTimeValue(a);
        const timeB = this.getReservationTimeValue(b);
        return timeA - timeB;
      });
    }
  },
  methods: {
    delete_item_dialog(rezervation){
      this.selected_delete =rezervation
      this.$root.modal_component.show_confirm_modal(this.$t('warning'),this.$t('are__you_sure_to_cancel_reservation'),[this.$t('ok')],this.confirm_delete_name);

    },
    delete_reservation(){
      var self = this;
      // console.log("route id "+this.$route.params.cat_id);
      var formData = new FormData();
formData.append('id',this.selected_delete.id)
      axios.post('/api/admin/order/delete_reservation', formData, {}).then(function (response) {

        var contents = response.data;

        self.$root.modal_component.show_api_response_modals(response);
        if(response.data.error==0){
          bus.$emit("get_dashboard_data", 'true');
        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    selectDay(dateStr) {
      this.selectedDate = dateStr;
      this.get_times_for_reserve();
    },
    previousMonth() {
      console.log("previours month",this.currentDate)
      if(this.$i18n.locale=='fa') {
        this.currentDate.subtract(1, 'jMonth');

      }else{
        this.currentDate.subtract(1, 'jMonth');

      }
      console.log("previours month",this.currentDate)

    },
    nextMonth() {
      if(this.$i18n.locale=='fa') {
        this.currentDate.add(1, 'jMonth');
      }else{
        this.currentDate.add(1, 'jMonth');
      }
    },
    getReservationCount(dateStr) {
      if (!this.reservations || this.reservations.length === 0) {
        return 0;
      }
      
      return this.reservations.filter(reservation => {
        if (!reservation.reserve_time || !reservation.reserve_time.date) {
          return false;
        }
        if (reservation.status==0) {
          return false;
        }
        const reserveDate = moment(reservation.reserve_time.date).format('YYYY-MM-DD');
        return reserveDate === dateStr;
      }).length;
    },
    getReservationTime(reservation) {
      if (!reservation.reserve_time || !reservation.reserve_time.date) {
        return '-';
      }
      return moment(reservation.reserve_time.date).format('HH:mm');
    },
    getReservationTimeValue(reservation) {
      if (!reservation.reserve_time || !reservation.reserve_time.date) {
        return 0;
      }
      const timeStr = moment(reservation.reserve_time.date).format('HH:mm');
      const [hours, minutes] = timeStr.split(':').map(Number);
      return hours * 60 + minutes;
    },
    get_times_for_reserve() {
      var self = this;


      const formData = new FormData();
      var url = "/api/admin/get_free_line_reserve_times";
      formData.append("admin_id", localStorage.getItem("user_id"));
      formData.append("selected_date", this.selectedDate);

      axios.post(url, formData, {}).then(function (response) {

        var current_times = response.data.times
        var current_other_reserves = response.data.other_reserves
        var disable_times = response.data.disable_times
        // this.selected_time = 0
        // var current_times = this.times.filter(x => new Date(x.date).getDate() == new Date(this.selected_date).getDate())
        // var current_other_reserves = this.other_reserves.filter(x => new Date(x.date).getDate() == new Date(this.selected_date).getDate())
        // console.log(this.current_times)
// console.log("times is",current_times)
        // console.log(this.current_other_reserves)
        current_times.forEach(function (val) {
          val.is_enable = true
          if (val.orders_count > 0) {
            val.is_enable = false
          }
          if (val.status == 0) {
            val.is_enable = false
          }

          var other_filter = current_other_reserves.filter(x => new Date(val.date) >= new Date(x.date) && new Date(val.date) <= new Date(x.end_date))
          if (other_filter.length > 0) {
            val.is_enable = false
          }
          var disable_filter = disable_times.filter(x => new Date(val.date) >= new Date(x.date) && new Date(val.date) <= new Date(x.end_date))
          if (disable_filter.length > 0) {
            val.is_enable = false
          }
        })
        console.log("times is",current_times)
        var uniqueArray =[]
            current_times.filter(x=>x.is_enable == true).forEach(function (val){
              uniqueArray.push(self.get_time(val.date));
        });
        self.free_times  = [...new Set(uniqueArray)];

      })
          .catch(function (error) {

            console.log(error);
          });

    },

  }
}
</script>

<style scoped>
.reservation-calendar {
  width: 100%;
}

.calendar-header {
  display: flex;
  justify-content: center;
  align-items: center;
}

.calendar-header .btn {
  color: #000 !important;
  /* border-color: #000 !important; */
}

.calendar-header .btn:hover {
  color: #000 !important;
  border-color: #000 !important;
}

.calendar-header .btn svg,
.calendar-header .btn .c-icon {
  color: #000 !important;
  fill: #000 !important;
}

.calendar-header .btn:disabled {
  color: #000 !important;
  opacity: 1;
  background-color: transparent !important;
}

.calendar-grid {
  display: flex;
  flex-direction: column;
}

.calendar-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
  margin-bottom: 10px;
}

.calendar-day-header {
  text-align: center;
  font-weight: bold;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 5px;
  font-size: 0.9rem;
}

.calendar-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
}

.calendar-day {
  min-height: 80px;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #fff;
  transition: all 0.2s;
  position: relative;
}

.calendar-day:hover {
  background-color: #f8f9fa;
  transform: scale(1.02);
}

.calendar-day.other-month {
  background-color: #f8f9fa;
  opacity: 0.5;
}

.calendar-day.today {
  background-color: #e3f2fd;
  border: 2px solid #2196F3;
  font-weight: bold;
}

.calendar-day.selected {
  background-color: #fff3cd;
  border: 2px solid #FFC107;
  font-weight: bold;
}

.calendar-day {
  cursor: pointer;
}

.day-number {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 5px;
}

.reservation-badge {
  background: linear-gradient(135deg, #2196F3 0%, #42A5F5 100%);
  color: white;
  font-size: 0.75rem;
  padding: 3px 8px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  font-weight: 500;
  margin-top: auto;
  text-align: center;
  width: 100%;
}

@media (max-width: 768px) {
  .calendar-day {
    min-height: 60px;
    padding: 5px;
  }
  
  .day-number {
    font-size: 0.85rem;
  }
  
  .reservation-badge {
    font-size: 0.65rem;
    padding: 2px 6px;
  }
  
  .calendar-day-header {
    font-size: 0.75rem;
    padding: 5px;
  }
}

.reservations-list {
  margin-top: 0;
}

@media (min-width: 768px) {
  .calendar-column {
    padding-left: 15px;
    flex: 0 0 60%;
    max-width: 60%;
  }
  
  .reservations-column {
    padding-right: 15px;
    flex: 0 0 40%;
    max-width: 40%;
  }
  
  .reservations-list {
    position: sticky;
    top: 20px;
  }
}

@media (max-width: 767px) {
  .reservations-list {
    margin-top: 2rem;
  }
}

.reservations-table {
  margin-bottom: 0;
  width: 100%;
  border: 1px solid #dee2e6;
  border-collapse: separate;
  border-spacing: 0;
}

.reservations-table thead th {
  vertical-align: middle;
  text-align: center;
  padding: 15px 10px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  font-weight: 600;
  color: #000;
}

.reservations-table thead th:first-child {
  border-top-right-radius: 0.375rem;
}

.reservations-table thead th:last-child {
  border-top-left-radius: 0.375rem;
}

.reservations-table tbody tr {
  height: 60px;
  vertical-align: middle;
}

.reservations-table tbody tr:nth-child(even) {
  background-color: #f8f9fa;
}

.reservations-table tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

.reservations-table tbody tr td {
  padding: 15px 10px;
  border-bottom: 1px solid #dee2e6;
  text-align: center;
  vertical-align: middle;
}


.reservations-table tbody tr:last-child td {
  border-bottom: none;
}

.reservations-table tbody tr td:first-child {
  border-right: 1px solid #dee2e6;
}

.reservations-table tbody tr td:not(:first-child):not(:last-child) {
  border-right: 1px solid #dee2e6;
}

.reservations-table tbody tr:hover {
  background-color: #e9ecef !important;
}

.call-button {
  min-width: 100px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 16px;
}

.call-button svg {
  flex-shrink: 0;
}

.button-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
}

@media (min-width: 768px) {
  .reservations-table {
    font-size: 0.85rem;
  }
  
  .reservations-table thead th {
    padding: 10px 8px;
    font-size: 0.9rem;
  }
  
  .reservations-table tbody tr {
    height: auto;
    min-height: 50px;
  }
  
  .reservations-table tbody tr td {
    padding: 8px 6px;
    font-size: 0.85rem;
  }
  
  .call-button {
    min-width: auto;
    padding: 4px 10px;
    font-size: 0.75rem;
    white-space: nowrap;
  }
  
  .call-button svg {
    width: 14px;
    height: 14px;
    margin-left: 4px;
  }
  
  .button-group {
    gap: 8px;
    justify-content: center;
    flex-wrap: nowrap;
  }
  
  .free-times-container {
    gap: 6px;
  }
  
  .free-time-item {
    font-size: 0.9rem;
    padding: 6px 10px;
  }
}

@media (max-width: 768px) {
  .button-group {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }
  .reservations-table tbody tr {
    height: 50px;
  }
  
  .reservations-table tbody tr td {
    padding: 12px 8px;
    font-size: 0.9rem;
  }
  
  .call-button {
    min-width: 80px;
    padding: 6px 12px;
    font-size: 0.85rem;
  }
  
  .call-button svg {
    width: 14px;
    height: 14px;
  }
}
.reservation-cancel{
  background: #ffcccc!important;
}

.free-times-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}

.free-time-item {
  font-size: 17px;
  border: 1px solid cornflowerblue;
  color: black;
  padding: 8px 12px;
  border-radius: 5px;
  background-color: #fff;
  white-space: nowrap;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .free-times-container {
    gap: 6px;
  }
  
  .free-time-item {
    font-size: 14px;
    padding: 6px 10px;
  }
}
</style>

